/**
 * Footer External Links Handler
 * Adds target="_blank" and rel attributes to external links in footer menu
 */

( function() {
	'use strict';

	function initFooterExternalLinks() {
		const footerMenu = document.querySelector( '.footer__menu' );

		if ( !footerMenu ) {
			return;
		}

		const links = footerMenu.querySelectorAll( 'a' );
		const currentDomain = window.location.hostname;

		links.forEach( function( link ) {
			const linkUrl = link.getAttribute( 'href' );

			// Skip if no href or it's an anchor
			if ( !linkUrl || linkUrl.startsWith( '#' ) ) {
				return;
			}

			// Check if link is external
			try {
				const linkDomain = new URL( linkUrl, window.location.origin ).hostname;

				if ( linkDomain !== currentDomain ) {
					// External link - add target and rel
					link.setAttribute( 'target', '_blank' );
					link.setAttribute( 'rel', 'noopener noreferrer' );
				}
			} catch ( e ) {
				// Invalid URL, skip
			}
		} );
	}

	// Initialize on DOM ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initFooterExternalLinks );
	} else {
		initFooterExternalLinks();
	}
}() );
